import React from 'react';

// Brand orange – icons stay this color by default
const ICON_ORANGE = '#ff6b35';

// Search Icon
export const SearchIcon = ({ color = ICON_ORANGE, size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="6" stroke={color} strokeWidth="1.5"/>
    <path d="M13 13L16 16" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Package/Box Icon
export const PackageIcon = ({ color = ICON_ORANGE, size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="8" y="12" width="32" height="28" rx="2" stroke={color} strokeWidth="2"/>
    <path d="M8 20L24 14L40 20" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M24 14V40" stroke={color} strokeWidth="2"/>
  </svg>
);

// Platform Icons
export const PCIcon = ({ color = ICON_ORANGE, size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="3" width="12" height="8" rx="1" stroke={color} strokeWidth="1.5"/>
    <path d="M5 11H11" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M7 13H9" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export const PlayStationIcon = ({ color = ICON_ORANGE, size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="6" stroke={color} strokeWidth="1.5"/>
    <path d="M6 6L10 6M6 8L10 8M6 10L8 10" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export const XboxIcon = ({ color = ICON_ORANGE, size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="6" stroke={color} strokeWidth="1.5"/>
    <path d="M6 6L10 10M10 6L6 10" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Check Icons
export const CheckIcon = ({ color = ICON_ORANGE, size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="7" cy="7" r="6" fill={color}/>
    <path d="M4 7L6 9L10 5" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Cart Icon
export const CartIcon = ({ color = ICON_ORANGE, size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 3H5L5.4 5M7 13H17L15 7H5.4M7 13L5.4 5M7 13L4.7 15.3C4.3 15.7 4.6 16.5 5.1 16.5H17M9 16.5C9.6 16.5 10 16.9 10 17.5C10 18.1 9.6 18.5 9 18.5C8.4 18.5 8 18.1 8 17.5C8 16.9 8.4 16.5 9 16.5ZM16 16.5C16.6 16.5 17 16.9 17 17.5C17 18.1 16.6 18.5 16 18.5C15.4 18.5 15 18.1 15 17.5C15 16.9 15.4 16.5 16 16.5Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const CheckSimpleIcon = ({ color = ICON_ORANGE, size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.3333 4L6 11.3333L2.66667 8" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Clock Icon
export const ClockIcon = ({ color = ICON_ORANGE, size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="6" stroke={color} strokeWidth="1.5"/>
    <path d="M8 4V8L10.5 10.5" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// User Icon
export const MenuIcon = ({ color = ICON_ORANGE, size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 12H21M3 6H21M3 18H21" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const UserIcon = ({ color = ICON_ORANGE, size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="6" r="3" stroke={color} strokeWidth="1.5"/>
    <path d="M4 17C4 13.6863 6.68629 11 10 11C13.3137 11 16 13.6863 16 17" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Lightning Icon
export const LightningIcon = ({ color = ICON_ORANGE, size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 2L3 10H8L7 14L13 6H8L9 2Z" fill={color}/>
  </svg>
);

// Chat Icon
export const ChatIcon = ({ color = ICON_ORANGE, size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 2C2.44772 2 2 2.44772 2 3V11C2 11.5523 2.44772 12 3 12H5V14C5 14.5523 5.44772 15 6 15C6.55228 15 7 14.5523 7 14V12H13C13.5523 12 14 11.5523 14 11V3C14 2.44772 13.5523 2 13 2H3Z" fill={color}/>
  </svg>
);

// Shield Icon
export const ShieldIcon = ({ color = ICON_ORANGE, size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M24 4L8 8V20C8 28.5 14.5 35.5 24 40C33.5 35.5 40 28.5 40 20V8L24 4Z" fill={color} fillOpacity="0.1" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M24 8L12 10.5V20C12 26.5 17 31.5 24 34.5C31 31.5 36 26.5 36 20V10.5L24 8Z" fill={color} fillOpacity="0.2"/>
    <path d="M20 24L22 26L28 20" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Notification Icon
export const NotificationIcon = ({ color = ICON_ORANGE, size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 2C7.23858 2 5 4.23858 5 7V10.5858L3.29289 12.2929C3.10536 12.4804 3 12.7348 3 13V15C3 15.5523 3.44772 16 4 16H16C16.5523 16 17 15.5523 17 15V13C17 12.7348 16.8946 12.4804 16.7071 12.2929L15 10.5858V7C15 4.23858 12.7614 2 10 2Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7 16V17C7 18.6569 8.34315 20 10 20C11.6569 20 13 18.6569 13 17V16" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Messages Icon
export const MessagesIcon = ({ color = ICON_ORANGE, size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 4C3 2.89543 3.89543 2 5 2H15C16.1046 2 17 2.89543 17 4V12C17 13.1046 16.1046 14 15 14H9L5 17V4Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6 7H14M6 10H11" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Globe Icon
export const GlobeIcon = ({ color = ICON_ORANGE, size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="6" stroke={color} strokeWidth="1.5"/>
    <path d="M2 8H14M8 2C9.5 4.5 10.5 6 11 8C10.5 10 9.5 11.5 8 14C6.5 11.5 5.5 10 5 8C5.5 6 6.5 4.5 8 2Z" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Sun Icon
export const SunIcon = ({ color = ICON_ORANGE, size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="3" stroke={color} strokeWidth="1.5"/>
    <path d="M8 1V3M8 13V15M15 8H13M3 8H1M13.5 2.5L12 4M4 12L2.5 13.5M13.5 13.5L12 12M4 4L2.5 2.5" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Moon Icon - Clean crescent moon design
export const MoonIcon = ({ color = ICON_ORANGE, size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.5 2C6.5 5.31371 9.18629 8 12.5 8C12.7893 8 13.0734 7.97434 13.35 7.92462C12.4058 9.23919 10.8571 10 9.16667 10C6.23858 10 3.83333 7.59477 3.83333 4.66667C3.83333 3.47619 4.26071 2.38095 4.98333 1.5C4.32857 1.5 3.71429 1.69048 3.19048 2.02381C2.66667 2.35714 2.2381 2.83333 1.95238 3.40476C1.66667 3.97619 1.52381 4.61905 1.52381 5.28571C1.52381 7.19048 3.04762 8.71429 4.95238 8.71429C5.61905 8.71429 6.2619 8.57143 6.83333 8.28571C7.40476 7.99999 7.88095 7.57143 8.21429 7.04762C8.54762 6.52381 8.7381 5.90476 8.7381 5.2381C8.7381 4.57143 8.59424 3.92857 8.30852 3.35714C8.02281 2.78571 7.59424 2.30952 7.07048 1.97619C6.54671 1.64286 5.92857 1.5 5.2619 1.5C5.02381 1.5 4.78571 1.52381 4.54762 1.57143" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Support/Chat Icon (for 24/7 support)
export const SupportIcon = ({ color = ICON_ORANGE, size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 1C4.13401 1 1 3.68629 1 7C1 8.5 1.5 9.9 2.3 11L1 15L5.2 13.7C6.1 14.1 7.05 14.3 8 14.3C11.866 14.3 15 11.6137 15 8.3C15 5.01371 11.866 1 8 1Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5 7H11M5 10H9" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Chevron Down Icon
export const ChevronDownIcon = ({ color = ICON_ORANGE, size = 12 }) => (
  <svg width={size} height={size} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 4.5L6 7.5L9 4.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const ChevronUpIcon = ({ color = ICON_ORANGE, size = 12 }) => (
  <svg width={size} height={size} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 7.5L6 4.5L9 7.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const ChevronLeftIcon = ({ color = ICON_ORANGE, size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 4L8 10L12 16" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const ChevronRightIcon = ({ color = ICON_ORANGE, size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 4L10 8L6 12" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const CloseIcon = ({ color = ICON_ORANGE, size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 5L15 15M15 5L5 15" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Filter Icon
export const FilterIcon = ({ color = ICON_ORANGE, size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 4H15M3 9H15M3 14H15" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="5" cy="4" r="1.5" fill={color}/>
    <circle cx="13" cy="9" r="1.5" fill={color}/>
    <circle cx="5" cy="14" r="1.5" fill={color}/>
  </svg>
);

// Star Icon
export const StarIcon = ({ color = ICON_ORANGE, size = 24, filled = true }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    {filled ? (
      <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill={color} stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    ) : (
      <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    )}
  </svg>
);

// Verified Icon
export const VerifiedIcon = ({ color = ICON_ORANGE, size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 1L10 5L14 6L10 7L8 11L6 7L2 6L6 5L8 1Z" fill={color}/>
    <path d="M5 8L7 10L11 6" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Thumbs Up Icon - Improved design
export const ThumbsUpIcon = ({ color = ICON_ORANGE, size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 22V11M2 13V20C2 21.1046 2.89543 22 4 22H16.4262C17.907 22 19.1662 20.9197 19.3914 19.4562L20.4683 12.4562C20.7479 10.6388 19.3411 9 17.5037 9H14C13.4477 9 13 8.55228 13 8V4.46584C13 3.10399 11.896 2 10.5342 2C10.2093 2 9.91498 2.1913 9.78306 2.48812L7.26394 8.57843C7.11196 8.91878 6.77778 9.14329 6.40674 9.14329H4C2.89543 9.14329 2 10.0387 2 11.1433V13C2 13.5523 2.44772 14 3 14H5C5.55228 14 6 14.4477 6 15V20C6 20.5523 5.55228 21 5 21H4C2.89543 21 2 20.1046 2 19V13Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Thumbs Down Icon - Improved design
export const ThumbsDownIcon = ({ color = '#ef4444', size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 2V13M22 11V4C22 2.89543 21.1046 2 20 2H7.57377C6.09298 2 4.83384 3.08029 4.60862 4.54382L3.53174 11.5438C3.25212 13.3612 4.65888 15 6.49626 15H10C10.5523 15 11 15.4477 11 16V19.5342C11 20.896 12.104 22 13.4658 22C13.7907 22 14.085 21.8087 14.2169 21.5119L16.7361 15.4216C16.888 15.0812 17.2222 14.8567 17.5933 14.8567H20C21.1046 14.8567 22 13.9613 22 12.8567V11C22 10.4477 21.5523 10 21 10H19C18.4477 10 18 9.55228 18 9V4C18 3.44772 18.4477 3 19 3H20C21.1046 3 22 3.89543 22 5V11Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Info Icon
export const InfoIcon = ({ color = ICON_ORANGE, size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="6" stroke={color} strokeWidth="1.5"/>
    <path d="M8 6V8M8 10H8.01" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Settings/Gear Icon
export const SettingsIcon = ({ color = ICON_ORANGE, size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z" stroke={color} strokeWidth="1.5"/>
    <path d="M15.8333 10C15.8333 10.2083 15.8333 10.4167 15.7917 10.625L17.125 12.5C17.3333 12.8333 17.25 13.2917 16.9167 13.5L15.0833 14.5833C14.75 14.7917 14.2917 14.7083 14.0833 14.375L12.75 12.5C12.4583 12.6667 12.125 12.7917 11.7917 12.875L11.6667 15C11.6667 15.375 11.3333 15.6667 10.9583 15.6667H9.04167C8.66667 15.6667 8.33333 15.375 8.33333 15L8.20833 12.875C7.875 12.7917 7.54167 12.6667 7.25 12.5L5.91667 14.375C5.70833 14.7083 5.25 14.7917 4.91667 14.5833L3.08333 13.5C2.75 13.2917 2.66667 12.8333 2.875 12.5L4.20833 10.625C4.16667 10.4167 4.16667 10.2083 4.16667 10C4.16667 9.79167 4.16667 9.58333 4.20833 9.375L2.875 7.5C2.66667 7.16667 2.75 6.70833 3.08333 6.5L4.91667 5.41667C5.25 5.20833 5.70833 5.29167 5.91667 5.625L7.25 7.5C7.54167 7.33333 7.875 7.20833 8.20833 7.125L8.33333 5C8.33333 4.625 8.66667 4.33333 9.04167 4.33333H10.9583C11.3333 4.33333 11.6667 4.625 11.6667 5L11.7917 7.125C12.125 7.20833 12.4583 7.33333 12.75 7.5L14.0833 5.625C14.2917 5.29167 14.75 5.20833 15.0833 5.41667L16.9167 6.5C17.25 6.70833 17.3333 7.16667 17.125 7.5L15.7917 9.375C15.8333 9.58333 15.8333 9.79167 15.8333 10Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Platform Icon Mapper
export const getPlatformIcon = (platform, color = ICON_ORANGE, size = 16) => {
  const icons = {
    'PC': <PCIcon color={color} size={size} />,
    'PlayStation': <PlayStationIcon color={color} size={size} />,
    'Xbox': <XboxIcon color={color} size={size} />,
  };
  return icons[platform] || <PCIcon color={color} size={size} />;
};

